import stripTrailingSlash from '@/core/utils/strip-trailing-slash';

const BOOKING_DETAIL_PATH_PATTERN = /^\/bookings\/[a-f0-9-]{36}$/i;

const isBookingDetailPathname = (pathname: string): boolean => {
  const cleanPath = stripTrailingSlash(
    pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?\//, '/').replace(/\?.*$/, ''),
  );

  return BOOKING_DETAIL_PATH_PATTERN.test(cleanPath);
};

export default isBookingDetailPathname;
